import React, { Component } from 'react';
import { Container } from '@mui/material';
import { NavMenu } from './NavMenu';


export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        return (
            <div>
               
                <Container maxWidth="false" sx={{ marginY: 0 }} className="vh-100">
                    {this.props.children}
                </Container>
            </div>
        );
    }
}
